import {ReactNode} from 'react';
import {usePermissionsFailureGuard} from '../hooks/usePermissionsFailureGuard.ts';

// Interim until FNP-1749. For a layout that mixes gated and ungated routes:
// wrap only the gated route elements, so a failed check leaves the ungated
// ones working.
export const PermissionsFailureGuard = ({children}: { children: ReactNode }) => {
    usePermissionsFailureGuard()
    return children
}
